import {RaikoIconTypes} from "./RaikoIconTypes";

export const RaikoIcon = ({icon = RaikoIconTypes.icTrash, className, onClick}) => {
    return (
        <div className={`${icon} ${className}`} onClick={onClick}/>
    )
}